export const COOKIE_POLICY_KEY = "uagCookiePolicyKey"
